interface TutorialModalProps {
  open: boolean;
  onDismiss: () => void;
}

export function TutorialModal({ open, onDismiss }: TutorialModalProps) {
  if (!open) {
    return null;
  }
  return (
    <div className="modal-overlay" role="presentation">
      <div
        className="modal tutorial-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="tutorial-modal-title"
      >
        <div className="modal__body tutorial-modal__body">
          <h2 id="tutorial-modal-title" className="tutorial-modal__title">
            <strong>Welcome to Gumballs.</strong> Recognition{" "}
            <span role="img" aria-label="smirking face">😏</span>, the Queen One way.
          </h2>
          <p>Coins come from your leaders. Gumballs come from your peers.</p>
          <p>
            Spend your coins — they expire. Gumballs live in your heart forever.
            That's science.
          </p>
          <p>
            Did someone help you out? Send them gumballs and tell them why. The
            reason matters more than the count.
          </p>
          <div className="tutorial-modal__cta-wrap">
            <button
              type="button"
              className="tutorial-modal__cta"
              onClick={onDismiss}
            >
              <svg
                className="tutorial-modal__cta-svg"
                viewBox="0 0 100 87"
                preserveAspectRatio="xMidYMid meet"
                aria-hidden="true"
              >
                <defs>
                  <linearGradient
                    id="tut-hex-fill"
                    x1="0"
                    y1="0"
                    x2="1"
                    y2="0.25"
                  >
                    <stop offset="0" stopColor="#ff4fd8" />
                    <stop offset="0.083" stopColor="#ff8c00" />
                    <stop offset="0.167" stopColor="#ffd700" />
                    <stop offset="0.25" stopColor="#c8ff00" />
                    <stop offset="0.333" stopColor="#00e5ff" />
                    <stop offset="0.417" stopColor="#c044ff" />
                    <stop offset="0.5" stopColor="#ff4fd8" />
                    <stop offset="0.583" stopColor="#ff8c00" />
                    <stop offset="0.667" stopColor="#ffd700" />
                    <stop offset="0.75" stopColor="#c8ff00" />
                    <stop offset="0.833" stopColor="#00e5ff" />
                    <stop offset="0.917" stopColor="#c044ff" />
                    <stop offset="1" stopColor="#ff4fd8" />
                  </linearGradient>
                  <clipPath id="tut-hex-clip">
                    <polygon points="25,3.5 75,3.5 100,43.5 75,83.5 25,83.5 0,43.5" />
                  </clipPath>
                  <filter
                    id="tut-hex-inset"
                    x="-5%"
                    y="-5%"
                    width="110%"
                    height="110%"
                  >
                    <feGaussianBlur in="SourceAlpha" stdDeviation="2.5" />
                    <feOffset dx="0" dy="2" />
                    <feComposite
                      in2="SourceAlpha"
                      operator="arithmetic"
                      k2="-1"
                      k3="1"
                      result="shadowDiff"
                    />
                    <feFlood floodColor="#000" floodOpacity="0.55" />
                    <feComposite in2="shadowDiff" operator="in" />
                    <feComposite in2="SourceGraphic" operator="over" />
                  </filter>
                </defs>
                <g clipPath="url(#tut-hex-clip)" filter="url(#tut-hex-inset)">
                  <rect
                    className="tutorial-modal__cta-rainbow"
                    x="-50"
                    y="-10"
                    width="400"
                    height="107"
                    fill="url(#tut-hex-fill)"
                  />
                </g>
                <polygon
                  points="25,3.5 75,3.5 100,43.5 75,83.5 25,83.5 0,43.5"
                  fill="none"
                  stroke="rgba(0, 0, 0, 0.45)"
                  strokeWidth="0.5"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="tutorial-modal__cta-label">HEX IT</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
